<div class="tab-pane active" id="pb-cdetails">
    <form [formGroup]="propertyForm" (ngSubmit)="submit(propertyForm.getRawValue())" #propform="ngForm">

        <h5 class="card-title mb-4">Property Description</h5>

        <!-- MODULE TYPE - SEPARATE ROW -->
        <div class="form-row mb-3">
            <div class="col-12">
                <label class="selector-label">Module Type <span class="text-danger">*</span></label>
                <div class="properties_btn compact-btn-group">
                    <ng-container *ngFor="let module of moduleList">
                        <ng-container *ngIf="module.moduleName.includes('Projects')">
                            <button type="button" class="btn btn-primary btn-sm rounded-pill"
                                [ngClass]="{'active':module.selected}" (click)="onChangeModule(module)">
                                {{module.moduleName}}
                            </button>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- LISTING TYPE - SEPARATE ROW -->
        <div class="form-row mb-3">
            <div class="col-12">
                <label class="selector-label">Listing Type <span class="text-danger">*</span></label>
                <div class="properties_btn compact-btn-group">
                    <ng-container *ngFor="let category of categoryList">
                        <button type="button" class="btn btn-primary btn-sm rounded-pill"
                            [ngClass]="{'active':category.selected}" (click)="changeCategory(category)">
                            {{category.categoryName}}
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- PROPERTY TYPE - SEPARATE ROW -->
        <div class="form-row mb-3" *ngIf="subCatList.length">
            <div class="col-12">
                <label class="selector-label">Property Type <span class="text-danger">*</span></label>
                <div class="properties_btn compact-btn-group">
                    <ng-container *ngFor="let subcat of subCatList">
                        <button type="button" class="btn btn-primary btn-sm rounded-pill"
                            [ngClass]="{'active':subcat.selected}" (click)="changeSubCategory(subcat)">
                            {{subcat.subCategoryName}}
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- COMPANY - SEPARATE ROW -->
        <div class="form-row mb-3">
            <div class="col-12">
                <label class="selector-label">Company <span class="text-danger">*</span></label>
                <div class="properties_btn compact-btn-group">
                    <ng-container *ngIf="companyList.length > 0">
                        <ng-container *ngFor="let company of companyList">
                            <button type="button" class="btn btn-primary btn-sm rounded-pill"
                                [ngClass]="{'active':company.selected}" (click)="changeCompany(company)">
                                {{company.companyName}}
                            </button>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="companyList.length === 0">
                        <div class="alert alert-warning" role="alert">
                            <p class="mb-0">No companies found. You need to add a company to continue.</p>
                            <button type="button" class="btn btn-primary btn-sm mt-2" (click)="navigateToAddCompany()">
                                <i class="fas fa-plus"></i> Add Company
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- PROJECT STATUS - SEPARATE ROW -->
        <div class="form-row mb-3">
            <div class="col-12">
                <label class="selector-label">Project Status <span class="text-danger">*</span></label>
                <div class="properties_btn compact-btn-group">
                    <button type="button" class="btn btn-primary btn-sm rounded-pill"
                        [ngClass]="{'active': projectStatus === 'Ongoing'}" (click)="changeProjectStatus('Ongoing')">
                        Ongoing
                    </button>
                    <button type="button" class="btn btn-primary btn-sm rounded-pill"
                        [ngClass]="{'active': projectStatus === 'Upcoming'}" (click)="changeProjectStatus('Upcoming')">
                        Upcoming
                    </button>
                    <button type="button" class="btn btn-primary btn-sm rounded-pill"
                        [ngClass]="{'active': projectStatus === 'Completed'}" (click)="changeProjectStatus('Completed')">
                        Completed
                    </button>
                </div>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col">
                <label for="projectName">Project Name <span class="text-danger">*</span></label>
                <div class="input-group">
                    <input type="text" 
                           class="form-control" 
                           [class.is-invalid]="hasError('projectName', 'required') || hasError('projectName', 'minlength') || hasError('projectName', 'maxlength')"
                           name="projectName" 
                           formControlName="projectName" 
                           placeholder="Enter project name (3-100 characters)" />
                </div>
                <!-- ✅ VALIDATION ERROR MESSAGES -->
                <div class="invalid-feedback d-block" *ngIf="(isSubmitted || projectName.touched) && projectName.errors">
                    <small *ngIf="projectName.errors['required']">Project Name is required</small>
                    <small *ngIf="projectName.errors['minlength']">Project Name must be at least 3 characters</small>
                    <small *ngIf="projectName.errors['maxlength']">Project Name cannot exceed 100 characters</small>
                </div>
                <!-- ✅ HELPER TEXT -->
                <small class="form-text text-muted" *ngIf="!projectName.errors || !((isSubmitted || projectName.touched))">
                    Enter a project name between 3-100 characters
                </small>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col">
                <div class="form-group">
                    <label for="projectDescription">Project Description <span class="text-danger">*</span></label>
                    <textarea class="form-control" 
                              [class.is-invalid]="hasError('projectDescription', 'required') || hasError('projectDescription', 'minlength') || hasError('projectDescription', 'maxlength')"
                              rows="4" 
                              id="projectDescription" 
                              name="projectDescription"
                              formControlName="projectDescription"
                              placeholder="Enter project description (10-1000 characters)"></textarea>
                    <!-- ✅ VALIDATION ERROR MESSAGES -->
                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || projectDescription.touched) && projectDescription.errors">
                        <small *ngIf="projectDescription.errors['required']">Project Description is required</small>
                        <small *ngIf="projectDescription.errors['minlength']">Project Description must be at least 10 characters</small>
                        <small *ngIf="projectDescription.errors['maxlength']">Project Description cannot exceed 1000 characters</small>
                    </div>
                    <!-- ✅ HELPER TEXT -->
                    <small class="form-text text-muted" *ngIf="!projectDescription.errors || !((isSubmitted || projectDescription.touched))">
                        Provide a detailed description (10-1000 characters)
                    </small>
                </div>
            </div>
        </div>

        <!-- ========================================= -->
        <!-- ✅ INDEPENDENT HOUSE CONFIGURATION -->
        <!-- ========================================= -->

        <!-- ============================= -->
        <!-- CONFIGURATION -->
        <!-- ============================= -->

        <ng-container *ngIf="showIndependentConfig === 'Apartment'">

            <!-- ADD TOWER -->
            <div class="mb-3">
                <label>Configuration :</label>

                <button type="button" class="btn btn-primary btn-sm ml-2" (click)="addTower()">
                    + Add Tower
                </button>
            </div>

            <!-- TOWERS -->
            <div formArrayName="towers">

                <div *ngFor="let tower of towers.controls; let tIndex = index" [formGroupName]="tIndex"
                    class="tower-box">

                    <!-- HEADER -->
                    <div class="d-flex justify-content-between align-items-center">

                        <!-- VIEW MODE -->
                        <ng-container *ngIf="!tower.value.isEditing; else editMode">

                            <h5 class="mb-0">
                                {{ tower.value.name }}
                                <i class="ml-2 edit-icon" (click)="enableEditTower(tIndex)">✏️</i>
                            </h5>

                        </ng-container>

                        <!-- EDIT MODE -->
                        <ng-template #editMode>
                            <input class="form-control" formControlName="name" (blur)="saveTowerName(tIndex)"
                                (keyup.enter)="saveTowerName(tIndex)" style="width: 200px;">
                        </ng-template>

                        <!-- REMOVE BUTTON -->
                        <button type="button" class="btn btn-danger btn-sm" (click)="removeTower(tIndex)">
                            Remove
                        </button>

                    </div>

                    <!-- FLOORS -->
                    <div class="form-row mt-2">
                        <div class="col-md-4">
                            <label>Floors <span class="text-danger">*</span></label>
                            <input type="number" 
                                   formControlName="floors" 
                                   class="form-control"
                                   [class.is-invalid]="tower.get('floors')?.touched && (tower.get('floors')?.hasError('required') || tower.get('floors')?.hasError('min'))"
                                   placeholder="e.g., 20">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || tower.get('floors')?.touched) && tower.get('floors')?.errors">
                                <small *ngIf="tower.get('floors')?.hasError('required')">Floors is required</small>
                                <small *ngIf="tower.get('floors')?.hasError('min')">Floors must be at least 1</small>
                                <small *ngIf="tower.get('floors')?.hasError('max')">Floors cannot exceed 100</small>
                            </div>
                        </div>
                    </div>

                    <!-- UNITS -->
                    <div class="form-row mt-2">

                        <div class="col-md-3">
                            <label>Total Units <span class="text-danger">*</span></label>
                            <input type="number" 
                                   formControlName="totalUnits" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || tower.get('totalUnits')?.touched) && (tower.get('totalUnits')?.hasError('required') || tower.get('totalUnits')?.hasError('min'))"
                                   placeholder="e.g., 100">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || tower.get('totalUnits')?.touched) && tower.get('totalUnits')?.errors">
                                <small *ngIf="tower.get('totalUnits')?.hasError('required')">Total Units is required</small>
                                <small *ngIf="tower.get('totalUnits')?.hasError('min')">Total Units must be at least 1</small>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label>Size Range (Sq Ft) <span class="text-danger">*</span></label>
                            <div class="d-flex gap-2">
                                <div class="flex-grow-1">
                                    <input type="number" 
                                           formControlName="minArea" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || tower.get('minArea')?.touched) && (tower.get('minArea')?.hasError('required') || tower.get('minArea')?.hasError('min'))"
                                           placeholder="Min">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || tower.get('minArea')?.touched) && tower.get('minArea')?.errors">
                                        <small *ngIf="tower.get('minArea')?.hasError('required')">Min Area required</small>
                                        <small *ngIf="tower.get('minArea')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>
                                <span class="align-self-center">to</span>
                                <div class="flex-grow-1">
                                    <input type="number" 
                                           formControlName="maxArea" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || tower.get('maxArea')?.touched) && (tower.get('maxArea')?.hasError('required') || tower.get('maxArea')?.hasError('min'))"
                                           placeholder="Max">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || tower.get('maxArea')?.touched) && tower.get('maxArea')?.errors">
                                        <small *ngIf="tower.get('maxArea')?.hasError('required')">Max Area required</small>
                                        <small *ngIf="tower.get('maxArea')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label>Price Per Sq Ft <span class="text-danger">*</span></label>
                            <input type="number" 
                                   formControlName="pricePerSqft" 
                                   class="form-control"
                                   [class.is-invalid]="tower.get('pricePerSqft')?.touched && (tower.get('pricePerSqft')?.hasError('required') || tower.get('pricePerSqft')?.hasError('min'))"
                                   placeholder="e.g., 2500">
                            <div class="invalid-feedback d-block" *ngIf="tower.get('pricePerSqft')?.touched && tower.get('pricePerSqft')?.errors">
                                <small *ngIf="tower.get('pricePerSqft')?.hasError('required')">Price Per Sq Ft is required</small>
                                <small *ngIf="tower.get('pricePerSqft')?.hasError('min')">Price must be at least 50</small>
                            </div>
                        </div>

                    </div>

                    <!-- FACING -->
                    <div formGroupName="facing" class="mt-3">
                        <label class="mr-3">Facing <span class="text-danger">*</span></label>

                        <div class="d-flex align-items-center gap-3 flex-wrap">

                            <label class="mb-0">
                                <input type="checkbox" formControlName="east"> East
                            </label>

                            <label class="mb-0">
                                <input type="checkbox" formControlName="west"> West
                            </label>

                            <label class="mb-0">
                                <input type="checkbox" formControlName="north"> North
                            </label>

                            <label class="mb-0">
                                <input type="checkbox" formControlName="south"> South
                            </label>

                        </div>
                        <small class="text-danger d-block mt-2" *ngIf="isSubmitted && !tower.get('facing.east')?.value && !tower.get('facing.west')?.value && !tower.get('facing.north')?.value && !tower.get('facing.south')?.value">
                            Please select at least one facing
                        </small>
                    </div>
                    <!-- CONFIG TABLE -->
                    <div formArrayName="configurations" class="mt-3">

                        <div class="table-header">
                            <span>Facing <span class="text-danger">*</span></span>
                            <span>BHK <span class="text-danger">*</span></span>
                            <span>Sq Ft <span class="text-danger">*</span></span>
                            <span>Price <span class="text-danger">*</span></span>
                            <span>Units <span class="text-danger">*</span></span>
                            <span>Available <span class="text-danger">*</span></span>
                            <span>Action</span>
                        </div>

                        <!-- FILTERED ROWS - Only show rows matching selected facing and sqft range -->
                        <div *ngFor="let i of getCachedTowerIndices(tIndex)" [formGroupName]="i"
                            class="table-row">

                            <div>
                                <select formControlName="facing" 
                                        class="form-control"
                                        [class.is-invalid]="false">
                                    <option value="">Select</option>
                                    <option *ngFor="let facing of getAvailableTowerFacings(tIndex)" [value]="facing">{{facing}}</option>
                                </select>

                            </div>

                            <div>
                                <select formControlName="bhk" 
                                        class="form-control"
                                        [class.is-invalid]="false">
                                    <option value="">Select</option>
                                    <option [value]="'1 BHK'">1 BHK</option>
                                    <option [value]="'2 BHK'">2 BHK</option>
                                    <option [value]="'3 BHK'">3 BHK</option>
                                    <option [value]="'4 BHK'">4 BHK</option>
                                    <option [value]="'5 BHK'">5 BHK</option>
                                </select>

                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="sqft" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getConfigurations(tIndex).at(i).get('sqft')?.touched) && (getConfigurations(tIndex).at(i).get('sqft')?.hasError('required') || getConfigurations(tIndex).at(i).get('sqft')?.hasError('min'))"
                                       placeholder="Sq Ft"
                                       #towerSqftInput
                                       (change)="getConfigurations(tIndex).at(i).get('sqft')?.setValue(Number(towerSqftInput.value), {emitEvent: false}); getConfigurations(tIndex).at(i).get('sqft')?.markAsTouched(); getConfigurations(tIndex).at(i).get('sqft')?.updateValueAndValidity()">
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getConfigurations(tIndex).at(i).get('sqft')?.touched) && getConfigurations(tIndex).at(i).get('sqft')?.hasError('required')">Sqft is required</small>
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getConfigurations(tIndex).at(i).get('sqft')?.touched) && getConfigurations(tIndex).at(i).get('sqft')?.hasError('min')">Sqft should be at least 1</small>
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getConfigurations(tIndex).at(i).get('sqft')?.touched) && !isTowerConfigSqftInRange(tIndex, i) && getConfigurations(tIndex).at(i).get('sqft')?.value">Sqft should be between {{getTowerForm(tIndex).get('minArea')?.value}} and {{getTowerForm(tIndex).get('maxArea')?.value}}</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="price" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getConfigurations(tIndex).at(i).get('price')?.touched) && (getConfigurations(tIndex).at(i).get('price')?.hasError('required') || getConfigurations(tIndex).at(i).get('price')?.hasError('min'))"
                                       placeholder="Price">

                                <small class="text-danger d-block" *ngIf="(isSubmitted || getConfigurations(tIndex).at(i).get('price')?.touched) && getConfigurations(tIndex).at(i).get('price')?.hasError('min')">Min 50k</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="units" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getConfigurations(tIndex).at(i).get('units')?.touched) && (getConfigurations(tIndex).at(i).get('units')?.hasError('required') || getConfigurations(tIndex).at(i).get('units')?.hasError('min'))"
                                       placeholder="Units">

                                <small class="text-danger d-block" *ngIf="(isSubmitted || getConfigurations(tIndex).at(i).get('units')?.touched) && getConfigurations(tIndex).at(i).get('units')?.hasError('min')">Min 1</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="available" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getConfigurations(tIndex).at(i).get('available')?.touched) && (getConfigurations(tIndex).at(i).get('available')?.hasError('required') || getConfigurations(tIndex).at(i).get('available')?.hasError('min'))"
                                       placeholder="Available">

                                <small class="text-danger d-block" *ngIf="(isSubmitted || getConfigurations(tIndex).at(i).get('available')?.touched) && getConfigurations(tIndex).at(i).get('available')?.hasError('min')">Min 0</small>
                            </div>

                            <div class="d-flex gap-1">
                                <button type="button" class="btn btn-success btn-sm"
                                    (click)="addConfigRowToTower(tIndex)">+</button>

                                <button type="button" class="btn btn-danger btn-sm"
                                    (click)="removeConfigRowFromTower(tIndex, i)" [disabled]="getConfigurations(tIndex).length <= 1">-</button>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </ng-container>

        <!-- ============================= -->
        <!-- INDEPENDENT HOUSE -->
        <!-- ============================= -->

        <ng-container *ngIf="showIndependentConfig === 'Independent House'">

            <!-- TOP FIELDS -->
            <div class="form-row mb-3">

                <div class="col-md-2">
                    <label>Total Units <span class="text-danger">*</span></label>
                    <input type="number" 
                           class="form-control" 
                           [class.is-invalid]="hasError('totalUnits', 'required') || hasError('totalUnits', 'min') || hasError('totalUnits', 'pattern') || (totalUnits.errors && totalUnits.errors['unitsMismatch'])"
                           formControlName="totalUnits"
                           placeholder="e.g., 100">
                    <!-- ✅ VALIDATION ERROR MESSAGES -->
                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || totalUnits.touched) && totalUnits.errors">
                        <small *ngIf="totalUnits.errors['required']">Total Units is required</small>
                        <small *ngIf="totalUnits.errors['min']">Total Units must be at least 1</small>
                        <small *ngIf="totalUnits.errors['max']">Total Units cannot exceed 10,000</small>
                        <small *ngIf="totalUnits.errors['pattern']">Please enter a valid number</small>
                        <small *ngIf="totalUnits.errors['unitsMismatch']">Total Units ({{ totalUnits.value }}) must match sum of configuration units ({{ getSumOfConfigurationUnits() }})</small>
                    </div>
                    <small class="form-text text-muted" *ngIf="!totalUnits.errors || !((isSubmitted || totalUnits.touched))">
                        Enter total number of units (1-10,000). Must match sum of all configuration units.
                    </small>
                </div>

                <div class="col-md-3">
                    <label>Size Range (Sq Ft) <span class="text-danger">*</span></label>

                    <div class="d-flex gap-2">
                        <div class="flex-grow-1">
                            <input type="number" 
                                   class="form-control" 
                                   [class.is-invalid]="hasError('minArea', 'required') || hasError('minArea', 'min') || hasError('minArea', 'pattern')"
                                   placeholder="Min" 
                                   formControlName="minArea">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || minArea.touched) && minArea.errors">
                                <small *ngIf="minArea.errors['required']">Min Area is required</small>
                                <small *ngIf="minArea.errors['min']">Min Area must be at least 100 sq ft</small>
                                <small *ngIf="minArea.errors['pattern']">Please enter a valid number</small>
                            </div>
                        </div>
                        <span class="align-self-center">to</span>
                        <div class="flex-grow-1">
                            <input type="number" 
                                   class="form-control" 
                                   [class.is-invalid]="hasError('maxArea', 'required') || hasError('maxArea', 'min') || hasError('maxArea', 'pattern')"
                                   placeholder="Max" 
                                   formControlName="maxArea">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || maxArea.touched) && maxArea.errors">
                                <small *ngIf="maxArea.errors['required']">Max Area is required</small>
                                <small *ngIf="maxArea.errors['min']">Max Area must be at least 100 sq ft</small>
                                <small *ngIf="maxArea.errors['pattern']">Please enter a valid number</small>
                            </div>
                        </div>
                    </div>
                    <small class="form-text text-muted" *ngIf="!minArea.errors && !maxArea.errors">
                        Size range in square feet (Min: 100+)
                    </small>
                </div>

                <div class="col-md-2">
                    <label>Structure <span class="text-danger">*</span></label>
                    <select class="form-control" 
                            [class.is-invalid]="hasError('structure', 'required')"
                            formControlName="structure">
                        <option value="">Select Structure</option>
                        <option value="simplex">Simplex</option>
                        <option value="duplex">Duplex</option>
                        <option value="g+1">G+1</option>
                        <option value="g+2">G+2</option>
                    </select>
                    <!-- ✅ VALIDATION ERROR MESSAGES -->
                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || structure.touched) && structure.errors">
                        <small *ngIf="structure.errors['required']">Structure is required</small>
                    </div>
                    <small class="form-text text-muted" *ngIf="!structure.errors">
                        Select the structure type
                    </small>
                </div>
            </div>

            <!-- FACING (HORIZONTAL) - SEPARATE ROW WITH SPACING -->
            <div class="form-row mb-3 mt-4" formGroupName="facing">
                <div class="col-12">
                    <label>Facing <span class="text-danger">*</span></label>

                    <div class="d-flex gap-3">

                        <label><input type="checkbox" formControlName="east"> East</label>
                        <label><input type="checkbox" formControlName="west"> West</label>
                        <label><input type="checkbox" formControlName="north"> North</label>
                        <label><input type="checkbox" formControlName="south"> South</label>

                    </div>
                    <small class="text-danger d-block mt-2" *ngIf="isSubmitted && !propertyForm.get('facing.east')?.value && !propertyForm.get('facing.west')?.value && !propertyForm.get('facing.north')?.value && !propertyForm.get('facing.south')?.value">
                        Please select at least one facing
                    </small>
                    <small class="form-text text-muted" *ngIf="!isSubmitted">Select at least one facing direction</small>
                </div>
            </div>

            <!-- TABLE -->
            <div formArrayName="configurations" class="w-100">

                    <!-- HEADER -->
                    <div class="table-header">
                        <span>Facing <span class="text-danger">*</span></span>
                        <span>BHK <span class="text-danger">*</span></span>
                        <span>Sq Ft <span class="text-danger">*</span></span>
                        <span>Price <span class="text-danger">*</span></span>
                        <span>Units <span class="text-danger">*</span></span>
                        <span>Available <span class="text-danger">*</span></span>
                        <span>Action</span>
                    </div>

                    <!-- ROWS - FILTERED BASED ON FACING AND SQFT RANGE -->
                    <div *ngFor="let i of getCachedConfigIndices()" [formGroupName]="i" class="table-row">

                        <div>
                            <select formControlName="facing" 
                                    class="form-control"
                                    [class.is-invalid]="false"
                                    (change)="onConfigChange(i)">
                                <option value="">Select</option>
                                <option *ngFor="let facing of getAvailableFacings()" [value]="facing">{{facing}}</option>
                            </select>
                        </div>

                        <div>
                            <select formControlName="bhk" 
                                    class="form-control"
                                    [class.is-invalid]="false"
                                    (change)="onConfigChange(i)">
                                <option value="">Select</option>
                                <option [value]="'1 BHK'">1 BHK</option>
                                <option [value]="'2 BHK'">2 BHK</option>
                                <option [value]="'3 BHK'">3 BHK</option>
                                <option [value]="'4 BHK'">4 BHK</option>
                                <option [value]="'5 BHK'">5 BHK</option>
                            </select>
                        </div>

                        <div>
                            <input type="number" 
                                   #sqftInput
                                   formControlName="sqft" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || configurations.at(i).get('sqft')?.touched) && configurations.at(i).get('sqft')?.hasError('min')"
                                   placeholder="Sq Ft"
                                   (change)="onConfigChange(i, sqftInput.value)">
                            <small class="text-danger d-block" *ngIf="(isSubmitted || configurations.at(i).get('sqft')?.touched) && configurations.at(i).get('sqft')?.hasError('min')">Sqft should be at least 1</small>
                            <small class="text-danger d-block" *ngIf="(isSubmitted || configurations.at(i).get('sqft')?.touched) && !isConfigSqftInRange(i) && configurations.at(i).get('sqft')?.value">Sqft should be between {{minArea.value}} and {{maxArea.value}}</small>
                        </div>

                        <div>
                            <input type="number" 
                                   formControlName="price" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || configurations.at(i).get('price')?.touched) && configurations.at(i).get('price')?.hasError('min')"
                                   placeholder="Price"
                                   (change)="onConfigChange(i)">
                            <small class="text-danger d-block" *ngIf="(isSubmitted || configurations.at(i).get('price')?.touched) && configurations.at(i).get('price')?.hasError('min')">Min 50,000</small>
                        </div>

                        <div>
                            <input type="number" 
                                   formControlName="units" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || configurations.at(i).get('units')?.touched) && configurations.at(i).get('units')?.hasError('min')"
                                   placeholder="Units"
                                   (change)="onConfigChange(i)">
                            <small class="text-danger d-block" *ngIf="(isSubmitted || configurations.at(i).get('units')?.touched) && configurations.at(i).get('units')?.hasError('min')">Min 1</small>
                        </div>

                        <div>
                            <input type="number" 
                                   formControlName="available" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || configurations.at(i).get('available')?.touched) && configurations.at(i).get('available')?.hasError('min')"
                                   placeholder="Available"
                                   (change)="onConfigChange(i)">
                            <small class="text-danger d-block" *ngIf="(isSubmitted || configurations.at(i).get('available')?.touched) && configurations.at(i).get('available')?.hasError('min')">Min 0</small>
                        </div>

                        <!-- ACTION BUTTON -->
                        <div class="d-flex gap-1">

                            <button type="button" class="btn btn-success btn-sm" (click)="addConfigRow()">
                                +
                            </button>

                            <button type="button" class="btn btn-danger btn-sm" (click)="removeConfigRow(i)" [disabled]="configurations.length <= 1">
                                -
                            </button>

                        </div>

                    </div>

                </div>
        </ng-container>

        <ng-container *ngIf="showIndependentConfig === 'Villa'">

            <!-- ADD PHASE -->
            <div class="mb-3">
                <label>Configuration :</label>

                <button type="button" class="btn btn-primary btn-sm ml-2" (click)="addPhase()">
                    + Add Phase
                </button>
            </div>

            <!-- PHASES -->
            <div formArrayName="phases">

                <div *ngFor="let phase of phases.controls; let pIndex = index" [formGroupName]="pIndex"
                    class="tower-box">

                    <!-- HEADER -->
                    <div class="d-flex justify-content-between align-items-center">

                        <!-- VIEW MODE -->
                        <ng-container *ngIf="!phase.value.isEditing; else editMode">

                            <h5 class="mb-0">
                                {{ phase.value.name }}
                                <i class="ml-2 edit-icon" (click)="enableEditPhase(pIndex)">✏️</i>
                            </h5>

                        </ng-container>

                        <!-- EDIT MODE -->
                        <ng-template #editMode>
                            <input class="form-control" formControlName="name" (blur)="savePhaseName(pIndex)"
                                (keyup.enter)="savePhaseName(pIndex)" style="width: 200px;">
                        </ng-template>

                        <!-- REMOVE -->
                        <button type="button" class="btn btn-danger btn-sm" (click)="removePhase(pIndex)">
                            Remove
                        </button>

                    </div>

                    <!-- UNITS + SIZE -->
                    <div class="form-row mt-2">

                        <div class="col-md-3">
                            <label>Total Units <span class="text-danger">*</span></label>
                            <input type="number" 
                                   formControlName="totalUnits" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || phase.get('totalUnits')?.touched) && (phase.get('totalUnits')?.hasError('required') || phase.get('totalUnits')?.hasError('min'))"
                                   placeholder="e.g., 50">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('totalUnits')?.touched) && phase.get('totalUnits')?.errors">
                                <small *ngIf="phase.get('totalUnits')?.hasError('required')">Total Units is required</small>
                                <small *ngIf="phase.get('totalUnits')?.hasError('min')">Total Units must be at least 1</small>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <label>Size Range (Sq Ft) <span class="text-danger">*</span></label>
                            <div class="d-flex gap-2">
                                <div class="flex-grow-1">
                                    <input type="number" 
                                           formControlName="minArea" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || phase.get('minArea')?.touched) && (phase.get('minArea')?.hasError('required') || phase.get('minArea')?.hasError('min'))"
                                           placeholder="Min">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('minArea')?.touched) && phase.get('minArea')?.errors">
                                        <small *ngIf="phase.get('minArea')?.hasError('required')">Min Area required</small>
                                        <small *ngIf="phase.get('minArea')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>
                                <span class="align-self-center">to</span>
                                <div class="flex-grow-1">
                                    <input type="number" 
                                           formControlName="maxArea" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || phase.get('maxArea')?.touched) && (phase.get('maxArea')?.hasError('required') || phase.get('maxArea')?.hasError('min'))"
                                           placeholder="Max">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('maxArea')?.touched) && phase.get('maxArea')?.errors">
                                        <small *ngIf="phase.get('maxArea')?.hasError('required')">Max Area required</small>
                                        <small *ngIf="phase.get('maxArea')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div formGroupName="structure" class="mt-2">
                            <label class="mr-3">Structure</label>

                            <div class="d-flex gap-3">

                                <label>
                                    <input type="checkbox" formControlName="villa"> Villa
                                </label>

                                <label>
                                    <input type="checkbox" formControlName="duplex"> Duplex
                                </label>

                                <label>
                                    <input type="checkbox" formControlName="triplex"> Triplex
                                </label>

                            </div>
                            <small class="form-text text-muted">Select at least one structure type</small>
                        </div>

                    </div>

                    <!-- FACING -->
                    <div formGroupName="facing" class="mt-3">
                        <label class="mr-3">Facing</label>

                        <div class="d-flex align-items-center gap-3 flex-wrap">

                            <label class="mb-0">
                                <input type="checkbox" formControlName="east"> East
                            </label>

                            <label class="mb-0">
                                <input type="checkbox" formControlName="west"> West
                            </label>

                            <label class="mb-0">
                                <input type="checkbox" formControlName="north"> North
                            </label>

                            <label class="mb-0">
                                <input type="checkbox" formControlName="south"> South
                            </label>

                        </div>
                    </div>

                    <!-- CONFIG TABLE -->
                    <div formArrayName="configurations" class="mt-3">

                        <div class="table-header">
                            <span>Facing <span class="text-danger">*</span></span>
                            <span>BHK <span class="text-danger">*</span></span>
                            <span>Sq Ft <span class="text-danger">*</span></span>
                            <span>Price <span class="text-danger">*</span></span>
                            <span>Units <span class="text-danger">*</span></span>
                            <span>Available <span class="text-danger">*</span></span>
                            <span>Action</span>
                        </div>

                        <!-- FILTERED ROWS - Only show rows matching selected facing and sqft range -->
                        <div *ngFor="let i of getCachedPhaseIndices(pIndex)"
                            [formGroupName]="i" class="table-row">

                            <div>
                                <select formControlName="facing" 
                                        class="form-control"
                                        [class.is-invalid]="false">
                                    <option value="">Select</option>
                                    <option *ngFor="let facing of getAvailablePhaseFacings(pIndex)" [value]="facing">{{facing}}</option>
                                </select>
                            </div>

                            <div>
                                <select formControlName="bhk" 
                                        class="form-control"
                                        [class.is-invalid]="false">
                                    <option value="">Select</option>
                                    <option [value]="'1 BHK'">1 BHK</option>
                                    <option [value]="'2 BHK'">2 BHK</option>
                                    <option [value]="'3 BHK'">3 BHK</option>
                                    <option [value]="'4 BHK'">4 BHK</option>
                                    <option [value]="'5 BHK'">5 BHK</option>
                                </select>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="sqft" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getPhaseConfigurations(pIndex).at(i).get('sqft')?.touched) && getPhaseConfigurations(pIndex).at(i).get('sqft')?.hasError('min')"
                                       placeholder="Sq Ft"
                                       #phaseSqftInput
                                       (change)="getPhaseConfigurations(pIndex).at(i).get('sqft')?.setValue(Number(phaseSqftInput.value), {emitEvent: false}); getPhaseConfigurations(pIndex).at(i).get('sqft')?.markAsTouched(); getPhaseConfigurations(pIndex).at(i).get('sqft')?.updateValueAndValidity()">
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPhaseConfigurations(pIndex).at(i).get('sqft')?.touched) && getPhaseConfigurations(pIndex).at(i).get('sqft')?.hasError('min')">Sqft should be at least 1</small>
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPhaseConfigurations(pIndex).at(i).get('sqft')?.touched) && !isPhaseConfigSqftInRange(pIndex, i) && getPhaseConfigurations(pIndex).at(i).get('sqft')?.value">Sqft should be between {{getPhaseForm(pIndex).get('minArea')?.value}} and {{getPhaseForm(pIndex).get('maxArea')?.value}}</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="price" 
                                       class="form-control"
                                       [class.is-invalid]="getPhaseConfigurations(pIndex).at(i).get('price')?.hasError('required') || getPhaseConfigurations(pIndex).at(i).get('price')?.hasError('min')"
                                       placeholder="Price">
                                <small class="text-danger d-block" *ngIf="getPhaseConfigurations(pIndex).at(i).get('price')?.hasError('min')">Min 50k</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="units" 
                                       class="form-control"
                                       [class.is-invalid]="getPhaseConfigurations(pIndex).at(i).get('units')?.hasError('required') || getPhaseConfigurations(pIndex).at(i).get('units')?.hasError('min')"
                                       placeholder="Units">
                                <small class="text-danger d-block" *ngIf="getPhaseConfigurations(pIndex).at(i).get('units')?.hasError('min')">Min 1</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="available" 
                                       class="form-control"
                                       [class.is-invalid]="getPhaseConfigurations(pIndex).at(i).get('available')?.hasError('required') || getPhaseConfigurations(pIndex).at(i).get('available')?.hasError('min')"
                                       placeholder="Available">
                                <small class="text-danger d-block" *ngIf="getPhaseConfigurations(pIndex).at(i).get('available')?.hasError('min')">Min 0</small>
                            </div>

                            <div class="d-flex gap-1">
                                <button type="button" class="btn btn-success btn-sm"
                                    (click)="addConfigRowToPhase(pIndex)">+</button>

                                <button type="button" class="btn btn-danger btn-sm"
                                    (click)="removeConfigRowFromPhase(pIndex, i)" [disabled]="getPhaseConfigurations(pIndex).length <= 1">-</button>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </ng-container>

        <ng-container *ngIf="showIndependentConfig === 'Society Plot' || showIndependentConfig === 'Other Plot'">


            <!-- PHASE BUTTONS -->
            <div class="mb-3 d-flex gap-2 align-items-center">

                <ng-container *ngFor="let phase of plotPhases.controls; let pIndex=index">
                    <span class="phase-pill">
                        {{phase.value.name}}
                    </span>
                </ng-container>

                <button type="button" class="btn btn-primary btn-sm" (click)="addPlotPhase()">+ Add</button>

            </div>

            <!-- PHASE LOOP -->
            <div formArrayName="plotPhases">

                <div *ngFor="let phase of plotPhases.controls; let pIndex=index" [formGroupName]="pIndex"
                    class="phase-box">

                    <!-- HEADER -->
                    <div class="d-flex justify-content-between align-items-center">
                        <h5>{{phase.value.name}}</h5>

                        <button type="button" class="btn btn-danger btn-sm" (click)="removePlotPhase(pIndex)">
                            Remove
                        </button>
                    </div>

                    <!-- FIELDS -->
                    <div class="form-row mt-2">

                        <!-- Total Units -->
                        <div class="col-md-2">
                            <label>Total Units <span class="text-danger">*</span></label>
                            <input type="number" 
                                   formControlName="totalUnits" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || phase.get('totalUnits')?.touched) && (phase.get('totalUnits')?.hasError('required') || phase.get('totalUnits')?.hasError('min'))"
                                   placeholder="e.g., 50">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('totalUnits')?.touched) && phase.get('totalUnits')?.errors">
                                <small *ngIf="phase.get('totalUnits')?.hasError('required')">Total Units is required</small>
                                <small *ngIf="phase.get('totalUnits')?.hasError('min')">Total Units must be at least 1</small>
                            </div>
                        </div>

                        <!-- Plot Size -->
                        <div class="col-md-3">
                            <label>Plot Size <span class="text-danger">*</span></label>

                            <div class="d-flex gap-2">
                                <select formControlName="plotSizeUnit" 
                                        class="form-control"
                                        [class.is-invalid]="(isSubmitted || phase.get('plotSizeUnit')?.touched) && phase.get('plotSizeUnit')?.hasError('required')">
                                    <option value="">Unit</option>
                                    <option>Sq Yd</option>
                                    <option>Sq Ft</option>
                                    <option>Cent</option>
                                </select>

                                <div class="flex-grow-1">
                                    <input type="number" 
                                           formControlName="minSize" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || phase.get('minSize')?.touched) && (phase.get('minSize')?.hasError('required') || phase.get('minSize')?.hasError('min'))"
                                           placeholder="Min">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('minSize')?.touched) && phase.get('minSize')?.errors">
                                        <small *ngIf="phase.get('minSize')?.hasError('required')">Min Size required</small>
                                        <small *ngIf="phase.get('minSize')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>
                                <div class="flex-grow-1">
                                    <input type="number" 
                                           formControlName="maxSize" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || phase.get('maxSize')?.touched) && (phase.get('maxSize')?.hasError('required') || phase.get('maxSize')?.hasError('min'))"
                                           placeholder="Max">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('maxSize')?.touched) && phase.get('maxSize')?.errors">
                                        <small *ngIf="phase.get('maxSize')?.hasError('required')">Max Size required</small>
                                        <small *ngIf="phase.get('maxSize')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Plot Dimension -->
                        <div class="col-md-2">
                            <label>Dimension (Feet) <span class="text-danger">*</span></label>
                            <div class="d-flex gap-2">
                                <input type="number" 
                                       formControlName="length" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || phase.get('length')?.touched) && (phase.get('length')?.hasError('required') || phase.get('length')?.hasError('min'))"
                                       placeholder="L">
                                <span class="align-self-center">×</span>
                                <input type="number" 
                                       formControlName="width" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || phase.get('width')?.touched) && (phase.get('width')?.hasError('required') || phase.get('width')?.hasError('min'))"
                                       placeholder="W">
                            </div>
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('length')?.touched || phase.get('width')?.touched) && (phase.get('length')?.errors || phase.get('width')?.errors)">
                                <small *ngIf="phase.get('length')?.hasError('required')">Length required</small>
                                <small *ngIf="phase.get('width')?.hasError('required')">Width required</small>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>Total Area (Acres) <span class="text-danger">*</span></label>
                            <input type="number" 
                                   formControlName="totalArea" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || phase.get('totalArea')?.touched) && (phase.get('totalArea')?.hasError('required') || phase.get('totalArea')?.hasError('min'))"
                                   placeholder="e.g., 10.5">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('totalArea')?.touched) && phase.get('totalArea')?.errors">
                                <small *ngIf="phase.get('totalArea')?.hasError('required')">Total Area is required</small>
                                <small *ngIf="phase.get('totalArea')?.hasError('min')">Min 100</small>
                            </div>
                        </div>

                    </div>
                    <div formGroupName="structure" class="mt-2">
                        <label class="mr-3">Structure</label>

                        <div class="d-flex gap-3">

                            <label>
                                <input type="checkbox" formControlName="villa"> Villa
                            </label>

                            <label>
                                <input type="checkbox" formControlName="duplex"> Duplex
                            </label>

                            <label>
                                <input type="checkbox" formControlName="triplex"> Triplex
                            </label>

                        </div>
                        <small class="form-text text-muted">Select at least one structure type</small>
                    </div>
                    <!-- FACING -->
                    <div formGroupName="facing" class="mt-3">
                        <label>Facing</label>

                        <div class="d-flex gap-3">
                            <label><input type="checkbox" formControlName="east"> East</label>
                            <label><input type="checkbox" formControlName="west"> West</label>
                            <label><input type="checkbox" formControlName="north"> North</label>
                            <label><input type="checkbox" formControlName="south"> South</label>
                        </div>
                        <small class="form-text text-muted">Select at least one facing direction</small>
                    </div>

                    <!-- CONFIG TABLE -->
                    <div formArrayName="configurations" class="mt-3">
                        <div class="table-header">
                            <span>Facing <span class="text-danger">*</span></span>
                            <span>Plot Area (Sq Yd) <span class="text-danger">*</span></span>
                            <span>Sq Ft Price <span class="text-danger">*</span></span>
                            <span>Unit Price <span class="text-danger">*</span></span>
                            <span>Units <span class="text-danger">*</span></span>
                            <span>Available <span class="text-danger">*</span></span>
                            <span>Action</span>
                        </div>

                        <!-- FILTERED ROWS - Only show rows matching selected facing and size range -->
                        <div *ngFor="let i of getCachedPlotIndices(pIndex)" [formGroupName]="i"
                            class="table-row">

                            <div>
                                <select formControlName="facing" 
                                        class="form-control"
                                        [class.is-invalid]="false">
                                    <option value="">Select</option>
                                    <option *ngFor="let facing of getAvailablePlotFacings(pIndex)" [value]="facing">{{facing}}</option>
                                </select>

                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="plotArea" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('plotArea')?.touched) && (getPlotConfigurations(pIndex).at(i).get('plotArea')?.hasError('required') || getPlotConfigurations(pIndex).at(i).get('plotArea')?.hasError('min'))"
                                       placeholder="Area"
                                       #plotAreaInput
                                       (change)="getPlotConfigurations(pIndex).at(i).get('plotArea')?.setValue(Number(plotAreaInput.value), {emitEvent: false}); getPlotConfigurations(pIndex).at(i).get('plotArea')?.markAsTouched(); getPlotConfigurations(pIndex).at(i).get('plotArea')?.updateValueAndValidity()">
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('plotArea')?.touched) && getPlotConfigurations(pIndex).at(i).get('plotArea')?.hasError('required')">Area is required</small>
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('plotArea')?.touched) && getPlotConfigurations(pIndex).at(i).get('plotArea')?.hasError('min')">Area should be at least 1</small>
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('plotArea')?.touched) && !isPlotConfigAreaInRange(pIndex, i) && getPlotConfigurations(pIndex).at(i).get('plotArea')?.value">Area should be between {{getPlotPhaseForm(pIndex).get('minSize')?.value}} and {{getPlotPhaseForm(pIndex).get('maxSize')?.value}}</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="sqftPrice" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('sqftPrice')?.touched) && (getPlotConfigurations(pIndex).at(i).get('sqftPrice')?.hasError('required') || getPlotConfigurations(pIndex).at(i).get('sqftPrice')?.hasError('min'))"
                                       placeholder="Sq Ft Price">

                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('sqftPrice')?.touched) && getPlotConfigurations(pIndex).at(i).get('sqftPrice')?.hasError('min')">Min 100</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="unitPrice" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('unitPrice')?.touched) && (getPlotConfigurations(pIndex).at(i).get('unitPrice')?.hasError('required') || getPlotConfigurations(pIndex).at(i).get('unitPrice')?.hasError('min'))"
                                       placeholder="Unit Price">

                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('unitPrice')?.touched) && getPlotConfigurations(pIndex).at(i).get('unitPrice')?.hasError('min')">Min 50k</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="units" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('units')?.touched) && (getPlotConfigurations(pIndex).at(i).get('units')?.hasError('required') || getPlotConfigurations(pIndex).at(i).get('units')?.hasError('min'))"
                                       placeholder="Units">

                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('units')?.touched) && getPlotConfigurations(pIndex).at(i).get('units')?.hasError('min')">Min 1</small>
                            </div>

                            <div>
                                <input type="number" 
                                       formControlName="available" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('available')?.touched) && (getPlotConfigurations(pIndex).at(i).get('available')?.hasError('required') || getPlotConfigurations(pIndex).at(i).get('available')?.hasError('min'))"
                                       placeholder="Available">

                                <small class="text-danger d-block" *ngIf="(isSubmitted || getPlotConfigurations(pIndex).at(i).get('available')?.touched) && getPlotConfigurations(pIndex).at(i).get('available')?.hasError('min')">Min 0</small>
                            </div>

                            <div class="d-flex gap-1">
                                <button type="button" class="btn btn-success btn-sm" (click)="addConfigRowToPlot(pIndex)">+</button>
                                <button type="button" class="btn btn-danger btn-sm" (click)="removeConfigRowFromPlot(pIndex, i)" [disabled]="getPlotConfigurations(pIndex).length <= 1">-</button>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </ng-container>

        <ng-container *ngIf="showIndependentConfig === 'Venture Plot'">
            <div class="mb-3 d-flex gap-2 align-items-center">

                <ng-container *ngFor="let phase of venturePhases.controls; let pIndex=index">
                    <span class="phase-pill">
                        {{phase.value.name}}
                    </span>
                </ng-container>

                <button type="button" class="btn btn-primary btn-sm" (click)="addVenturePhase()">+ Add</button>
            </div>
            <!-- PHASE LOOP -->
            <div formArrayName="venturePhases">

                <div *ngFor="let phase of venturePhases.controls; let pIndex=index" [formGroupName]="pIndex"
                    class="phase-box">

                    <!-- PHASE BUTTONS -->




                    <!-- HEADER -->
                    <div class="d-flex justify-content-between align-items-center">
                        <h5>{{phase.value.name}}</h5>

                        <button type="button" class="btn btn-danger btn-sm" (click)="removeVenturePhase(pIndex)">
                            Remove
                        </button>
                    </div>

                    <!-- FIELDS -->
                    <div class="form-row mt-2">

                        <!-- Total Units -->
                        <div class="col-md-2">
                            <label>Total Units <span class="text-danger">*</span></label>
                            <input type="number"
                                   formControlName="totalUnits" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || phase.get('totalUnits')?.touched) && (phase.get('totalUnits')?.hasError('required') || phase.get('totalUnits')?.hasError('min'))"
                                   placeholder="e.g., 50">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('totalUnits')?.touched) && phase.get('totalUnits')?.errors">
                                <small *ngIf="phase.get('totalUnits')?.hasError('required')">Total Units is required</small>
                                <small *ngIf="phase.get('totalUnits')?.hasError('min')">Total Units must be at least 1</small>
                            </div>
                        </div>

                        <!-- Plot Size -->
                        <div class="col-md-3">
                            <label>Plot Size <span class="text-danger">*</span></label>

                            <div class="d-flex gap-2">
                                <select formControlName="plotSizeUnit" 
                                        class="form-control"
                                        [class.is-invalid]="(isSubmitted || phase.get('plotSizeUnit')?.touched) && phase.get('plotSizeUnit')?.hasError('required')">
                                    <option value="">Unit</option>
                                    <option>Sq Yd</option>
                                    <option>Sq Ft</option>
                                    <option>Cent</option>
                                </select>

                                <div class="flex-grow-1">
                                    <input type="number"
                                           formControlName="minArea" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || phase.get('minArea')?.touched) && (phase.get('minArea')?.hasError('required') || phase.get('minArea')?.hasError('min'))"
                                           placeholder="Min">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('minArea')?.touched) && phase.get('minArea')?.errors">
                                        <small *ngIf="phase.get('minArea')?.hasError('required')">Min Area required</small>
                                        <small *ngIf="phase.get('minArea')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>

                                <div class="flex-grow-1">
                                    <input type="number"
                                           formControlName="maxArea" 
                                           class="form-control"
                                           [class.is-invalid]="(isSubmitted || phase.get('maxArea')?.touched) && (phase.get('maxArea')?.hasError('required') || phase.get('maxArea')?.hasError('min'))"
                                           placeholder="Max">
                                    <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('maxArea')?.touched) && phase.get('maxArea')?.errors">
                                        <small *ngIf="phase.get('maxArea')?.hasError('required')">Max Area required</small>
                                        <small *ngIf="phase.get('maxArea')?.hasError('min')">Min 100</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Plot Dimension -->
                        <div class="col-md-3">
                            <label>Dimension (Feet) <span class="text-danger">*</span></label>

                            <div class="dimension-box">
                                <input type="number"
                                       formControlName="length" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || phase.get('length')?.touched) && (phase.get('length')?.hasError('required') || phase.get('length')?.hasError('min'))"
                                       placeholder="Length">

                                <span class="multiply">×</span>

                                <input type="number"
                                       formControlName="width" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || phase.get('width')?.touched) && (phase.get('width')?.hasError('required') || phase.get('width')?.hasError('min'))"
                                       placeholder="Width">
                            </div>
                            <small class="text-muted">in feet</small>
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('length')?.touched || phase.get('width')?.touched) && (phase.get('length')?.errors || phase.get('width')?.errors)">
                                <small *ngIf="phase.get('length')?.hasError('required')">Length required</small>
                                <small *ngIf="phase.get('width')?.hasError('required')">Width required</small>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label>Total Area (Acres) <span class="text-danger">*</span></label>
                            <input type="number"
                                   formControlName="totalArea" 
                                   class="form-control"
                                   [class.is-invalid]="(isSubmitted || phase.get('totalArea')?.touched) && (phase.get('totalArea')?.hasError('required') || phase.get('totalArea')?.hasError('min'))"
                                   placeholder="e.g., 10.5">
                            <div class="invalid-feedback d-block" *ngIf="(isSubmitted || phase.get('totalArea')?.touched) && phase.get('totalArea')?.errors">
                                <small *ngIf="phase.get('totalArea')?.hasError('required')">Total Area is required</small>
                                <small *ngIf="phase.get('totalArea')?.hasError('min')">Min 100</small>
                            </div>
                        </div>

                    </div>

                    <!-- STRUCTURE -->
                    <div formGroupName="structure" class="mt-2">
                        <label class="mr-3">Structure <span class="text-danger">*</span></label>

                        <div class="d-flex gap-3">
                            <label>
                                <input type="checkbox" formControlName="villa"> Villa
                            </label>

                            <label>
                                <input type="checkbox" formControlName="duplex"> Duplex
                            </label>

                            <label>
                                <input type="checkbox" formControlName="triplex"> Triplex
                            </label>
                        </div>
                        <small class="text-danger d-block mt-2" *ngIf="isSubmitted && !phase.get('structure.villa')?.value && !phase.get('structure.duplex')?.value && !phase.get('structure.triplex')?.value">
                            Please select at least one structure type
                        </small>
                    </div>

                    <!-- FACING -->
                    <div formGroupName="facing" class="mt-3">

                        <label class="mr-3">Facing <span class="text-danger">*</span></label>

                        <div class="d-flex gap-3">
                            <label><input type="checkbox" formControlName="east"> East</label>
                            <label><input type="checkbox" formControlName="west"> West</label>
                            <label><input type="checkbox" formControlName="north"> North</label>
                            <label><input type="checkbox" formControlName="south"> South</label>
                        </div>
                        <small class="text-danger d-block mt-2" *ngIf="isSubmitted && !phase.get('facing.east')?.value && !phase.get('facing.west')?.value && !phase.get('facing.north')?.value && !phase.get('facing.south')?.value">
                            Please select at least one facing
                        </small>
                    </div>

                    <!-- CONFIG TABLE -->
                    <div formArrayName="configurations" class="mt-3">
                        <div class="table-header">
                            <span>Facing</span>
                            <span>Villa Area(Sq Yd)</span>
                            <span>Bhk</span>
                            <span>Sq Feet</span>
                            <span>Sq Feet Price</span>
                            <span>Unit Price</span>
                            <span>Total Units</span>
                        </div>

                        <!-- FILTERED ROWS - Only show rows matching selected facing and area range -->
                        <div *ngFor="let i of getCachedVentureIndices(pIndex)" [formGroupName]="i"
                            class="table-row">

                            <select formControlName="facing" 
                                    class="form-control"
                                    [class.is-invalid]="false">
                                <option value="">Select</option>
                                <option *ngFor="let facing of getAvailableVentureFacings(pIndex)" [value]="facing">{{facing}}</option>
                            </select>

                            <div>
                                <input type="number"
                                       formControlName="villaArea" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getVentureConfigs(pIndex).at(i).get('villaArea')?.touched) && (getVentureConfigs(pIndex).at(i).get('villaArea')?.hasError('required') || !isVentureConfigAreaInRange(pIndex, i))"
                                       #villaAreaInput
                                       (change)="getVentureConfigs(pIndex).at(i).get('villaArea')?.setValue(Number(villaAreaInput.value), {emitEvent: false}); getVentureConfigs(pIndex).at(i).get('villaArea')?.markAsTouched(); getVentureConfigs(pIndex).at(i).get('villaArea')?.updateValueAndValidity()">
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getVentureConfigs(pIndex).at(i).get('villaArea')?.touched) && getVentureConfigs(pIndex).at(i).get('villaArea')?.hasError('required')">Required</small>
                                <small class="text-danger d-block" *ngIf="(isSubmitted || getVentureConfigs(pIndex).at(i).get('villaArea')?.touched) && !isVentureConfigAreaInRange(pIndex, i) && getVentureConfigs(pIndex).at(i).get('villaArea')?.value">Area should be between {{getVenturePhaseForm(pIndex).get('minArea')?.value}} and {{getVenturePhaseForm(pIndex).get('maxArea')?.value}}</small>
                            </div>

                            <select formControlName="bhk" 
                                    class="form-control"
                                    [class.is-invalid]="(isSubmitted || getVentureConfigs(pIndex).at(i).get('bhk')?.touched) && getVentureConfigs(pIndex).at(i).get('bhk')?.hasError('required')">
                                <option value="">Select</option>
                                <option [value]="'1 BHK'">1 BHK</option>
                                <option [value]="'2 BHK'">2 BHK</option>
                                <option [value]="'3 BHK'">3 BHK</option>
                                <option [value]="'4 BHK'">4 BHK</option>
                            </select>


                            <div>
                                <input type="number"
                                       formControlName="sqFeet" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getVentureConfigs(pIndex).at(i).get('sqFeet')?.touched) && getVentureConfigs(pIndex).at(i).get('sqFeet')?.hasError('required')"
                                       #sqFeetInput
                                       (change)="getVentureConfigs(pIndex).at(i).get('sqFeet')?.setValue(Number(sqFeetInput.value), {emitEvent: false}); getVentureConfigs(pIndex).at(i).get('sqFeet')?.markAsTouched(); getVentureConfigs(pIndex).at(i).get('sqFeet')?.updateValueAndValidity()">

                            </div>

                            <div>
                                <input type="number"
                                       formControlName="sqFeetPrice" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getVentureConfigs(pIndex).at(i).get('sqFeetPrice')?.touched) && getVentureConfigs(pIndex).at(i).get('sqFeetPrice')?.hasError('required')">

                            </div>

                            <div>
                                <input type="number"
                                       formControlName="unitPrice" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getVentureConfigs(pIndex).at(i).get('unitPrice')?.touched) && getVentureConfigs(pIndex).at(i).get('unitPrice')?.hasError('required')">

                            </div>

                            <div>
                                <input type="number"
                                       formControlName="units" 
                                       class="form-control"
                                       [class.is-invalid]="(isSubmitted || getVentureConfigs(pIndex).at(i).get('units')?.touched) && getVentureConfigs(pIndex).at(i).get('units')?.hasError('required')">

                            </div>

                            <div>
                                <button type="button" (click)="addConfigRowToVenture(pIndex)">+</button>
                                <button type="button" (click)="removeConfigRowFromVenture(pIndex, i)">-</button>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </ng-container>

        <div>
            <button type="submit" class="btn btn-primary btn-lg mb-2 float-right mr-2">Next</button>
        </div>
    </form>
</div>